
import Waypoint from 'Waypoint';
import $ from 'jquery';

export default function(waypoints, waypointContext) {


	return function(idx, el) {

		const playVideo = function(vid) {
			vid = document.getElementById(vid);
			var playPromise = vid.play();


			if (playPromise !== undefined) {
				playPromise.then(function() {
					// Automatic playback started!
				}).catch(function(error) {
					vid.muted = true;
					vid.play();
					// Automatic playback failed.
					// Show a UI element to let the user manually start playback.
				});
			}
		};

		const pauseVideo = function(vid) {
			vid = document.getElementById(vid);
			vid.pause();
		};

		const isVideoPlaying = function(video) {
			return video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2;
		}


		const $el = $(el);
		const $tgt = $('.' + $el.data('target') );
		const clazz = $el.data('class');
		const $tgtRemove = $('.' + $el.data('target-remove') );
		const clazzRemove = $el.data('class-remove');
		const offset = $el.data('offset') || 100;
		
		const isVideo = $el.data('video');
		const playV = $el.data('play');
		const playPreviousV = $el.data('playsprevious');
		// console.log( $tgt, clazz, $tgtRemove, clazzRemove, offset );


		waypoints.push(
			new Waypoint({
				element: el,
				handler: function(direction) {
					
					// pause all
					if(isVideo) {
						$('video').each(function(v) {
							var videoID = $(this).attr('id');

							v = document.getElementById(videoID);
							if(isVideoPlaying(v)) {
								// console.log('===  triggers-with-videosplayinline.js [57] === playing');
								// pauseVideo( v );
								v.pause();
							}
						});
					}

					if( direction === 'down' ) {
						$tgt.addClass( clazz );
						$tgtRemove.removeClass( clazzRemove );

						if(isVideo) {
							var vid = $('#video-'+playV);
							// first time only
							if(!$(vid).attr('src')) {
								$(vid).attr('src', $(vid).attr('data-src') );
							}
							playVideo( 'video-'+playV );
						}

					} else {
						$tgtRemove.addClass( clazzRemove );
						$tgt.removeClass( clazz );

						if(isVideo) {
							if(playV>1) {
								playVideo( 'video-'+(playV-1) );
							}
 							
						}
					}

					

					if( $el.hasClass('js-trigger-resize') ) {
						// console.log('should be triggering resize');
						$(window).trigger('resize');
					}

				},
				context: waypointContext,
				offset: offset + '%'
			})
		);

	}

};



// WEBPACK FOOTER //
// ./src/js/proj/waypoints/triggers-with-videosplayinline.js